/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteSigintSignalSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteSigintSignalSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteSigintSignalSecurity = {
  option1?: DeleteSigintSignalSecurityOption1 | undefined;
  option2?: DeleteSigintSignalSecurityOption2 | undefined;
};

export type DeleteSigintSignalRequest = {
  /**
   * Custom signal ID
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteSigintSignalSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteSigintSignalSecurityOption1$outboundSchema: z.ZodMiniType<
  DeleteSigintSignalSecurityOption1$Outbound,
  DeleteSigintSignalSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteSigintSignalSecurityOption1ToJSON(
  deleteSigintSignalSecurityOption1: DeleteSigintSignalSecurityOption1,
): string {
  return JSON.stringify(
    DeleteSigintSignalSecurityOption1$outboundSchema.parse(
      deleteSigintSignalSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteSigintSignalSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteSigintSignalSecurityOption2$outboundSchema: z.ZodMiniType<
  DeleteSigintSignalSecurityOption2$Outbound,
  DeleteSigintSignalSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function deleteSigintSignalSecurityOption2ToJSON(
  deleteSigintSignalSecurityOption2: DeleteSigintSignalSecurityOption2,
): string {
  return JSON.stringify(
    DeleteSigintSignalSecurityOption2$outboundSchema.parse(
      deleteSigintSignalSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteSigintSignalSecurity$Outbound = {
  Option1?: DeleteSigintSignalSecurityOption1$Outbound | undefined;
  Option2?: DeleteSigintSignalSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteSigintSignalSecurity$outboundSchema: z.ZodMiniType<
  DeleteSigintSignalSecurity$Outbound,
  DeleteSigintSignalSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteSigintSignalSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteSigintSignalSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteSigintSignalSecurityToJSON(
  deleteSigintSignalSecurity: DeleteSigintSignalSecurity,
): string {
  return JSON.stringify(
    DeleteSigintSignalSecurity$outboundSchema.parse(deleteSigintSignalSecurity),
  );
}

/** @internal */
export type DeleteSigintSignalRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteSigintSignalRequest$outboundSchema: z.ZodMiniType<
  DeleteSigintSignalRequest$Outbound,
  DeleteSigintSignalRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteSigintSignalRequestToJSON(
  deleteSigintSignalRequest: DeleteSigintSignalRequest,
): string {
  return JSON.stringify(
    DeleteSigintSignalRequest$outboundSchema.parse(deleteSigintSignalRequest),
  );
}
